<template>
    <div class="row">
        <div class="col-12">
            <h4 class="full-width" v-if="showadd">{{$t('PROMOTIONS.title2')}}</h4>
            <div class="row" v-if="newPromotion">
                <div class="col-12">
                    <el-form ref="regular-promotion">
                        <el-form-item label="Price">
                                    <vue-numeric class="form-control-sm mb-0 greycolors"
                                        :currency="symbol"
                                        :separator="decimalSeparator"
                                        :decimal-separator="separator"
                                        currency-symbol-position="suffix"
                                        :precision="fractionalDigits"
                                        :min="0"
                                        @blur="changeHandler"
                                        v-model="newPromotion.price"></vue-numeric>
                        </el-form-item>
                        <el-form-item label="Date">
                            <el-col :span="11">
                            <date-range-picker
                                        class="row ml-2"
                                        :inline="true"
                                        @dateChanged="dateChanged"
                                        :dateRange="dateRange"
                                        :showPickers="false"
                                        >
                        </date-range-picker>
                            </el-col>
                        </el-form-item>

                    </el-form>
                </div>
            </div>
            <div v-show="!noTable" v-for="(promotion, index) in regularPromotions"
                 :key="`promotion-regular-${promotion.id}-${index}`" class="row">
                <div class="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                    <p :class="classList(promotion)">From
                        <strong>{{parseDate(promotion.startTime)}}</strong>
                        to
                        <strong>{{parseDate(promotion.endTime)}}</strong>
                        <template v-if="hasFinished(promotion)">
                            {{$t('PROMOTIONS.promotionFinished')}}
                        </template>
                        <template v-else-if="hasStarted(promotion)">
                            {{daysLeft(promotion)}}
                        </template>
                        <template v-else>
                            {{daysToStart(promotion)}}
                        </template>
                    </p>
                </div>
                <div class="col-8 col-md-3 col-lg-4 d-flex
                            justify-content-center align-items-center">
                    <p>{{$t('COMMON.price')}} <strong>
                        <vue-numeric :decimal-separator="decimalSeparator"
                                     :separator="separator"
                                     :currency="symbol"
                                     currency-symbol-position="suffix"
                                     :read-only="true"
                                     :precision="fractionalDigits"
                                     :value="promotion.price"></vue-numeric>
                        </strong>
                    </p>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import DateRangePicker from '../../Shared/Datepicker/DateRangePicker.vue';
import FormInput from '../../Shared/UI/Form/FormInput';
import CphButton from '../../Shared/UI/Button/CphButton';
import PromotionMixin from './PromotionMixin';
import VueNumeric from 'vue-numeric';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'regular-promotion',
    data () {
        return {
            newPromotion: {
                startTime: '',
                endTime: '',
                price: 0,
                productId: this.productChosen.id,
                original: this.originalPriceId, //standard price id
                active: false, // is promotion active
                type: 'period' // bulk or period
            },
            form: {},
            message: '',
            dateRange: [],
        };
    },
    mixins: [PromotionMixin],
    components: {
        DateRangePicker,
        FormInput,
        CphButton,
        VueNumeric
    },
    props: {
        productChosen: {},
        newPromotionData: {
            type: Object,
            default: null
        },
        showadd: {
            type: Boolean
        },
        regularPromotions: {
            type: Array
        },
        symbol: '',
        noTable: {
            default: false,
            type: Boolean
        },
        fractionalDigits: 0,
        decimalSeparator: {
            deafult: "."
        },
        separator: {
             default: ","
        }
    },
    watch: {
        newPromotion (newVal, oldVal) {
            this.newPromotion = newVal;
        }
    },
    methods: {
        changeHandler(){
            if(this.newPromotion.price && this.newPromotion.startTime && this.newPromotion.endTime){
                if (this.newPromotion.price > this.standardPrice) {
                    return this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.higherPrice'), shouldGoToPrevPage: false,
                        callback: (decision = false) => {
                            if(decision) {
                                this.$emit('addPromotion', {promotion: {...this.newPromotion}, type: 'period'});
                            }else {
                                this.newPromotion = {
                                    startTime: '',
                                    endTime: '',
                                    price: 0,
                                    productId: this.productChosen.id,
                                    original: this.originalPriceId, //standard price id
                                    active: false, // is promotion active
                                    type: 'period' // bulk or period
                                }
                                this.date = []
                                this.$emit('removePromotion', {type: 'period'})
                            }
                        }});
                }else {
                    this.$emit('addPromotion', {promotion: {...this.newPromotion}, type: 'period'});
                }
            }else {
                this.message = 'Invalid promotion';
            }
        },
        dateChanged (date){
            this.newPromotion.startTime = date[0];
            this.newPromotion.endTime = date[1];
            this.changeHandler();
        },
        handleTimeChange (time, type) {
            let method = type === 'startTime' ? 'startOf' : 'endOf';
            this.newPromotion[type] = this.$utils.moment(time)[method]('day').format();
            this.changeHandler();
        }
    }
};
</script>

<style lang="scss" scoped>
  .styled{
      border: 1px solid #DCDFE6;
      height: 40px;
  }
  .modal-header{
    background-color: var(--color-primary, #729fcc);
  }
  label.fixed-height{
    line-height: 40px;
  }
  .greycolors {
      width: 15vw;
      min-width: 4rem;
      border: 1px solid #DCDFE6;
  }
</style>
